import { DropdownOptionModel } from './dropdown-option-model';

import { GovernmentSurveyRequest } from '../shared/models/index';

import RaceEnum = GovernmentSurveyRequest.RaceEnum;
import GenderEnum = GovernmentSurveyRequest.GenderEnum;
import EthnicityEnum = GovernmentSurveyRequest.EthnicityEnum;

export const RACE_OR_ORIGIN_OPTIONS: DropdownOptionModel<RaceEnum>[] = [
  { value: RaceEnum.AmericanIndian, display: 'American Indian or Alaska Native' },
  { value: RaceEnum.Asian, display: 'Asian' },
  { value: RaceEnum.Black, display: 'Black or African American' },
  { value: RaceEnum.NativeHawaian, display: 'Native Hawaiian or Pacific Islander' },
  { value: RaceEnum.White, display: 'White' },
  { value: RaceEnum.NotProvided, display: 'I prefer not to disclose' }
];

export const ETHNICITY_OPTIONS: DropdownOptionModel<EthnicityEnum>[] = [
  { value: EthnicityEnum.Hispanic, display: 'Hispanic or Latino' },
  { value: EthnicityEnum.NonHispanic, display: 'Not Hispanic or Latino' },
  { value: EthnicityEnum.NotProvided, display: 'I prefer not to disclose' }
];

export const GENDER_OPTIONS: DropdownOptionModel<GenderEnum>[] = [
  { value: GenderEnum.Female, display: 'Female' },
  { value: GenderEnum.Male, display: 'Male' },
  { value: GenderEnum.NotProvided, display: 'I prefer not to disclose' }
];
